module.exports = __webpack_public_path__ + "img/pv-add.a51b3727.svg";